import {
    CommandResponse,
    IntraDaySchedule,
    RevisionedCommandResponse,
    StudyEntityType,
    toIntraDaySchedule,
} from '@faro/study-designer-model';
import axios from 'axios';
import { createStudyEntityHookFactory } from '../createStudyEntityHookFactory';
import { ScheduleOfActivitiesQueryParameter, StudyPathParameter, VariantQueryParameter } from '../parameter';

export type IntraDaySchedulePathParameters = StudyPathParameter;

export type IntraDayScheduleQueryParameters = VariantQueryParameter & ScheduleOfActivitiesQueryParameter;

const factory = createStudyEntityHookFactory<IntraDaySchedule>(StudyEntityType.IntraDaySchedule);

export const useIntradaySchedules = factory.list(
    ({ studyId, ...query }: IntraDayScheduleQueryParameters & IntraDaySchedulePathParameters) =>
        axios
            .get(`/api/study-designer/studies/${studyId}/intra-day-schedules`, { params: query })
            .then(response => response.data?.map(toIntraDaySchedule) ?? [])
);
export const useIntradayScheduleUpdate = factory.mutate(
    (request: IntraDaySchedule): Promise<RevisionedCommandResponse<CommandResponse>> =>
        axios
            .put(`/api/study-designer/studies/${request.studyId}/intra-day-schedules/${request.id}`, request)
            .then(response => response.data)
);
